import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export const useAIRovoButtonEnablement = (): boolean => {
	const { isAdminHubAIEnabled, isRovoLLMEnabled } = useSessionData();
	// environment-aware enablement via feature encoding
	const isAIFeatureEnabled = isFeatureEnabled('confluence', 'confluence-ai');
	return isAIFeatureEnabled && isAdminHubAIEnabled && isRovoLLMEnabled;
};
